export const GET_STUDENTS = 'GET_STUDENTS';
export const GET_USERS = 'GET_USERS';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const GET_ROLES = 'GET_ROLES';
